import { FC, useEffect, useState } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import { TaskIcon1, TaskIcon2, TaskIcon3, TaskIcon4, TaskIcon5, QuestionIcon } from '../../Svg';
import { useLang } from '@/app/utils/useLang';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import { getMemberHolidayTask, makeMemberHolidayRewardEarn } from '@/components/MembersDay/apis';
import './index.scss';
import getLocal from '@/app/utils/getLocal';
import { message, Tooltip } from 'antd-v5';
import throttle from 'lodash/throttle';
import { shopnowMay } from '../../constants';
interface IProps {
    handleShowEcoCredits: (type: string) => void;
}
type ISource = 'Y25_KNOW_BRAND' | 'Y25_KNOW_MEMBER' | 'Y25_SHARE_STORY';

const MAX_REFERRAL_NUM = 20;
const MAX_PURCHASE_NUM = 2;

const PointsTask: FC<IProps> = ({ handleShowEcoCredits }) => {
    const { t } = useLang('membersday.membersdaytask25');
    const { campaignInfo, referralInfo, isLogin, inBlackList } = useMembersStore();
    const { locale, pathname } = getLocal();
    const shopnowUrl = shopnowMay[locale] || `https://${locale}.ecoflow.com/pages/members-festival`;

    const handleInBlackList = () => {
        if (inBlackList) {
            message.error(t('membersdaybanner25_no_eligible'));
            return;
        }
    };

    const toRegisterPage = () => {
        if (!isLogin) {
            location.href = `/${locale}/register?redirect=${encodeURIComponent(`/${locale}${pathname}#energy`)}`;
            return;
        }
    };

    const toShopify = () => {
        handleInBlackList();
        window.open(shopnowUrl, '_blank');
        // location.href = 'https://us.ecoflow.com/pages/members-festival';
    };

    const initData = () => {
        if (!campaignInfo || !referralInfo || !isLogin) return;
        /**
         * firstConsumeFlag 是否已首次下单 true:是 false:否
         * knowBrandFlag 是否已了解品牌 true:是 false:否
         * knowMemberFlag 是否已了解会员 true:是 false:否
         * referralCount 推荐人数
         * repeatConsumeCount 复购数量
         * shareStoryFlag 是否已分享故事 true:是 false:否
         *  */
        getMemberHolidayTask(locale, campaignInfo.campaignId, referralInfo.planId).then((res) => {
            if (res.code !== '0' || !res.data) return message.error(res.message);
            const newList = [...list]; // list固定有7个
            const { knowBrandFlag, knowMemberFlag, referralCount, shareStoryFlag, firstConsumeFlag, repeatConsumeCount } = res.data;

            if (knowBrandFlag) newList[1].isFinsh = true;

            if (knowMemberFlag) newList[2].isFinsh = true;

            newList[3].title = t.rich('task4_title', { referralCount: referralCount > MAX_REFERRAL_NUM ? MAX_REFERRAL_NUM : referralCount });
            if (referralCount >= MAX_REFERRAL_NUM) newList[3].isFinsh = true;

            if (shareStoryFlag) newList[4].isFinsh = true;

            if (firstConsumeFlag) {
                newList[5].title = newList[5].title.replace('0', '1');
                newList[5].isFinsh = true;
            }

            newList[6].title = t.rich('task7_title', { repeatConsumeCount: repeatConsumeCount > MAX_PURCHASE_NUM ? MAX_PURCHASE_NUM : repeatConsumeCount });
            if (repeatConsumeCount >= MAX_PURCHASE_NUM) newList[6].isFinsh = true;
            // campaignInfo变动后函数需要更新
            newList[1].onClick = () => handleFinsh('Y25_KNOW_BRAND');
            newList[2].onClick = () => handleFinsh('Y25_KNOW_MEMBER');
            newList[3].onClick = () => {
                handleInBlackList();
                !inBlackList && document.getElementById('referral')?.scrollIntoView(true);
            };
            newList[4].onClick = () => handleFinsh('Y25_SHARE_STORY');
            newList[5].onClick = toShopify;
            newList[6].onClick = toShopify;
            setList(newList);
        });
    };

    const handleFinsh = throttle(
        (source: ISource) => {
            handleInBlackList();
            if (campaignInfo) {
                makeMemberHolidayRewardEarn(locale, {
                    campaignId: campaignInfo.campaignId,
                    source,
                }).then((res) => {
                    if (res?.code !== '0') return message.error(res.message);
                    if (source === 'Y25_KNOW_BRAND') {
                        document.getElementById('introduction')?.scrollIntoView(true);
                        handleShowEcoCredits('a');
                    }
                    if (source === 'Y25_KNOW_MEMBER') {
                        document.getElementById('introduction')?.scrollIntoView(true);
                        handleShowEcoCredits('b');
                    }
                    if (source === 'Y25_SHARE_STORY') {
                        document.getElementById('UGC')?.scrollIntoView(true);
                    }
                    initData();
                });
            }
        },
        1000,
        { trailing: false },
    );

    const defaultList = [
        {
            title: t('task1_title'),
            tips: '',
            awardList: [
                {
                    icon: <TaskIcon1 />,
                    text: t('task1_item1_text'),
                },
                {
                    icon: <TaskIcon2 />,
                    text: t('task1_item2_text'),
                    tips: t.rich('task1_item2_text_tips', {
                        link: (text: string) => (
                            <a
                                href={`https://www.ecoflow.com/${locale}/ecocredits`}
                                target="_blank"
                                rel="noreferrer"
                                style={{ color: '#fff', textDecoration: 'underline' }}
                            >
                                {text}
                            </a>
                        ),
                    }),
                },
                {
                    icon: <TaskIcon2 />,
                    text: t('task1_item3_text'),
                },
                {
                    icon: <TaskIcon3 />,
                    text: t('task1_item4_text'),
                },
            ],
            defaultBtnText: t('task_btn_joinnow'),
            isFinsh: isLogin, // 是否已登陆
            onClick: toRegisterPage,
        },
        {
            title: t('task2_title'),
            tips: '',
            awardList: [
                {
                    icon: <TaskIcon4 />,
                    text: t('task2_ecocredits'),
                },
                {
                    icon: <TaskIcon5 />,
                    text: t('task2_points'),
                },
            ],
            defaultBtnText: t('task_btn_completetask'),
            isFinsh: false, // 是否已了解品牌
            onClick: () => handleFinsh('Y25_KNOW_BRAND'),
        },
        {
            title: t('task3_title'),
            tips: '',
            awardList: [
                {
                    icon: <TaskIcon4 />,
                    text: t('task3_ecocredits'),
                },
                {
                    icon: <TaskIcon5 />,
                    text: t('task3_points'),
                },
            ],
            defaultBtnText: t('task_btn_completetask'),
            isFinsh: false, // 是否已了解会员
            onClick: () => handleFinsh('Y25_KNOW_MEMBER'),
        },
        {
            title: t.rich('task4_title', {
                referralCount: 0,
            }),
            tips: '',
            awardList: [
                {
                    icon: <TaskIcon4 />,
                    text: t('task4_ecocredits'),
                },
                {
                    icon: <TaskIcon5 />,
                    text: t('task4_points'),
                },
            ],
            defaultBtnText: t('task_btn_referral'),
            isFinsh: false, // 是否邀请20位注册用户
            onClick: () => {
                handleInBlackList();
                !inBlackList && document.getElementById('referral')?.scrollIntoView(true);
            },
        },
        {
            title: t('task5_title'),
            tips: '',
            awardList: [
                {
                    icon: <TaskIcon4 />,
                    text: t('task5_ecocredits'),
                },
                {
                    icon: <TaskIcon5 />,
                    text: t('task5_points'),
                },
            ],
            defaultBtnText: t('task_btn_completetask'),
            isFinsh: false, // 是否已分享故事
            onClick: () => handleFinsh('Y25_SHARE_STORY'),
        },
        {
            title: t('task6_title'),
            tips: t('task6_title_tips'),
            awardList: [
                {
                    icon: <TaskIcon4 />,
                    text: t('task6_ecocredits'),
                },
                {
                    icon: <TaskIcon5 />,
                    text: t('task6_points'),
                },
            ],
            defaultBtnText: t('task_btn_purchasenow'),
            isFinsh: false, // 是否已首次下单
            onClick: toShopify,
        },
        {
            title: t.rich('task7_title', {
                repeatConsumeCount: 0,
            }),
            tips: '',
            awardList: [
                {
                    icon: <TaskIcon4 />,
                    text: t('task7_ecocredits'),
                },
                {
                    icon: <TaskIcon5 />,
                    text: t('task7_points'),
                },
            ],
            defaultBtnText: t('task_btn_purchasenow'),
            isFinsh: false, // 复购数量
            onClick: toShopify,
        },
    ];

    const [list, setList] = useState(defaultList);

    useEffect(() => {
        initData();
    }, [campaignInfo, referralInfo, inBlackList]);

    return (
        <div className={'PointsTask'}>
            <div className="task-list">
                {list.map((item, index) => (
                    <div className={`task-item task-item-${index + 1}`} key={index}>
                        <span className="index">{index + 1}</span>
                        <p className="task-title">
                            {item.title}
                            {item.tips && (
                                <Tooltip arrow={false} placement="top" title={<div style={{ whiteSpace: 'pre-line' }}>{item.tips}</div>}>
                                    <QuestionIcon />
                                </Tooltip>
                            )}
                        </p>
                        <div className="task-content">
                            <ul className="award-list">
                                {item.awardList.map((awardItem: any, index: number) => (
                                    <li className={`award-item award-item-${index + 1}`} key={awardItem.text}>
                                        {awardItem.icon}
                                        <span className="text">
                                            {awardItem.text}
                                            {awardItem.tips && (
                                                <Tooltip arrow={false} placement="top" title={<div style={{ whiteSpace: 'pre-line' }}>{awardItem.tips}</div>}>
                                                    <QuestionIcon />
                                                </Tooltip>
                                            )}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                            {isLogin ? (
                                <EditorLink
                                    className={`complete-btn ${item.isFinsh && !inBlackList ? 'disabled' : ''}`}
                                    dataLayer={
                                        index < 5
                                            ? {
                                                  event: 'uaEvent',
                                                  event_name: 'activity_button',
                                                  page_name: 'members-festival',
                                                  list_name: item.title,
                                                  button_name: item.defaultBtnText,
                                                  function: 'Anchor',
                                              }
                                            : { event: 'uaEvent', event_name: 'buy', product_name: 'none', position: `Members-Festival_${item.title}` }
                                    }
                                    onClick={item.isFinsh && !inBlackList ? () => null : item.onClick}
                                >
                                    {item.isFinsh && !inBlackList ? t('task_btn_finished') : item.defaultBtnText}
                                </EditorLink>
                            ) : (
                                <EditorLink
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'activity_join',
                                        button_name: `${item.title}_${t('task_btn_joinnow')}`,
                                        list_name: item.title,
                                    }}
                                    className={`complete-btn`}
                                    onClick={() => toRegisterPage()}
                                >
                                    {t('task_btn_joinnow')}
                                </EditorLink>
                            )}

                            {/* 第一条特殊处理 添加一段文案 */}
                            {index === 0 && !isLogin && (
                                <p className="first-task-login">
                                    {t.rich('membersdayalready', {
                                        link: (text: string) => (
                                            <EditorLink
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'activity_join',
                                                    button_name: `${t('task1_title')}_${text}`,
                                                    list_name: t('task1_title'),
                                                }}
                                                href={`/${locale}/login?redirect=${encodeURIComponent(`/${locale}${pathname}#energy`)}`}
                                            >
                                                {text}
                                            </EditorLink>
                                        ),
                                    })}
                                </p>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PointsTask;
